import Radio from './radio';
import RadioItem from './radio-item';

Radio.RadioItem = RadioItem;

export default Radio;
